import { SALUTATION } from "@/types";
import { z } from "zod";
import { getEmailSchema, getAddressSchema, getMessageSchema, getNameSchema, getPhoneSchema, getPreferencesSchema, getStickyContactSchema, getSuggestPriceSchema, } from "../validation";
export const useValidationSchema = (t, options) => {
    return z
        .object({
        salutation: z.nativeEnum(SALUTATION, {
            errorMap: () => ({
                message: t("contact.form.salutation_error_empty"),
            }),
        }),
    })
        .merge(getNameSchema(t, options))
        .merge(getEmailSchema(t))
        .merge(getPhoneSchema(t, options))
        .merge(getAddressSchema(t, options))
        .merge(getMessageSchema(t, options))
        .merge(getPreferencesSchema(t, options))
        .merge(getStickyContactSchema(t, options))
        .merge(getSuggestPriceSchema(t, options));
};
